module.exports = __webpack_public_path__ + "static/media/foto2.893c2705.png";